import TopSectionCollapse from './components/TopSectionCollapse';
import BodySectionCollapse from './components/BodySectionCollapse';

export default {
  install (app) {
    app.component('top-section-collapse', TopSectionCollapse);
    app.component('body-section-collapse', BodySectionCollapse);
  }
};
